var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { compose, FormModal, graphql, Header, Separator, TextField, useShowFlag, getErrorMessage, ReactRouter } from "@atlassiansox/microscopekit";
import { RadioGroup } from "@atlaskit/radio";
import { DateTimePicker } from "@atlaskit/datetime-picker";
import StartWargameMutation from "../../graphql/start-wargame.mutation.graphql";
import { ScheduleType, FaultCategory } from "../../../__generated__/graphql-global-types";
import SectionMessage from "@atlaskit/section-message";
import { chain, isEmpty } from "lodash";
import { getPreviousPath } from "../../utils/getOnDemandHomePath";
var TemplateScheduleForm = function (props) {
    var _a = __read(useState(ScheduleType.none), 2), scheduleType = _a[0], setScheduleType = _a[1];
    var history = useHistory();
    var scheduleAt;
    var showFlag = useShowFlag();
    var wireMockApiPaths = chain(props.wargameTemplate.taskGroup)
        .flatMap(function (taskGroup) { return taskGroup.faults; })
        .filter(function (fault) { return fault.faultCategory === FaultCategory.application_layer; })
        .map(function (fault) { return fault.parameters.url; })
        .uniq()
        .value();
    var isWiremockWarningVisible = !isEmpty(wireMockApiPaths);
    var url = ReactRouter.useRouteMatch().url;
    return (React.createElement("div", null,
        React.createElement(FormModal, { actions: {
                submit: {
                    text: scheduleType === ScheduleType.none ? "Execute" : "Schedule",
                    onSubmit: function (data) {
                        var cron = data.cron;
                        var ticket_id = data.ticket_id;
                        return props
                            .startWargameMutation({
                            variables: {
                                wargameInput: {
                                    warGameTemplateId: parseInt(props.wargameTemplate.id
                                        ? props.wargameTemplate.id
                                        : "0"),
                                    warGameTicketId: ticket_id,
                                    scheduleInfo: {
                                        cron: cron,
                                        scheduleType: scheduleType,
                                        scheduleTime: scheduleAt
                                            ? new Date(scheduleAt).toISOString()
                                            : scheduleAt
                                    }
                                }
                            }
                        })
                            .then(function (response) {
                            showFlag({
                                type: "success",
                                title: "Success!",
                                message: scheduleType === ScheduleType.none
                                    ? "Wargame started"
                                    : "Wargame scheduled"
                            });
                            props.setIsExecutionModelOpen(false);
                            if (scheduleType === ScheduleType.none) {
                                history.push(getPreviousPath(url));
                            }
                        })
                            .catch(function (reason) {
                            showFlag({
                                type: "error",
                                title: "Error!",
                                message: getErrorMessage(reason)
                            });
                        });
                    }
                },
                close: {
                    text: "Close",
                    onClose: function () {
                        props.setIsExecutionModelOpen(false);
                    }
                }
            }, isOpen: props.isExecutionModalOpen, heading: "Execute Wargame Plan", key: "FormModel" },
            React.createElement("label", null,
                React.createElement(Header, null, "Schedule Type"),
                React.createElement(RadioGroup, { options: [
                        {
                            name: "schedule_type",
                            label: "Run Now",
                            value: ScheduleType.none,
                            isChecked: scheduleType === ScheduleType.none
                        },
                        {
                            name: "schedule_type",
                            label: "One Time",
                            value: ScheduleType.once,
                            isChecked: scheduleType === ScheduleType.once
                        },
                        {
                            name: "schedule_type",
                            label: "Recurring",
                            value: ScheduleType.recurring,
                            isChecked: scheduleType === ScheduleType.recurring
                        }
                    ], onChange: function (event) {
                        setScheduleType(event.target.value);
                    }, isRequired: true })),
            React.createElement("div", { hidden: scheduleType !== ScheduleType.recurring },
                React.createElement(TextField, { name: "cron", placeholder: "*/20 * * * *", label: "Cron", isRequired: scheduleType === ScheduleType.recurring, key: "schedule_type" })),
            React.createElement("div", { hidden: scheduleType !== ScheduleType.once },
                React.createElement(Separator, null),
                React.createElement(Header, null, "Schedule Time"),
                React.createElement(DateTimePicker, { name: "schedule_at", id: "schedule_at", onChange: function (value) {
                        scheduleAt = value;
                    } })),
            React.createElement(TextField, { name: "ticket_id", label: "Wargame Ticket [Optional]", placeholder: "GIJOE-5164", key: "ticket_id" }),
            isWiremockWarningVisible && (React.createElement(React.Fragment, null,
                React.createElement("br", null),
                React.createElement(SectionMessage, { appearance: "warning", title: "Please update URLs for wire mock" },
                    "For wire mock faults, please update the URLs of the API requests in your application code. Learn more",
                    " ",
                    React.createElement("a", { href: "http://go/brahmos-application-layer-faults", target: "_blank", rel: "noopener noreferrer" }, "here"),
                    ".",
                    React.createElement("ul", null, wireMockApiPaths.map(function (apiPath) { return (React.createElement("li", { key: apiPath },
                        "Replace \"https://<original-hostname>",
                        apiPath,
                        "\" with \"",
                        React.createElement("strong", null,
                            "https://brahmos-wiremock.staging.atl-paas.net/",
                            props.serviceId,
                            apiPath ? apiPath : "/<url>"),
                        "\"")); }))))))));
};
export var TemplateScheduleFormView = compose(graphql(StartWargameMutation, {
    name: "startWargameMutation",
    options: function (props) { return ({
        query: StartWargameMutation,
        variables: { wargameInput: { warGameTemplateId: parseInt(props.id) } }
    }); }
}))(TemplateScheduleForm);
